import { useTranslations } from "next-intl"

import { Row } from "@/components/ui"
import type { ListingPagination } from "@/lib/listing-pagination"

const pageLinkClass =
  "font-display text-body-sm inline-flex h-8 min-w-8 items-center justify-center rounded-full px-200 tabular-nums transition-colors focus-visible:ring-brand focus-visible:ring-2 focus-visible:outline-none"

export const ListingPageLinks = ({ pagination }: { pagination: ListingPagination }) => {
  const t = useTranslations("marketplace.product")
  return (
    <nav aria-label={t("pagination.label")}>
      <Row as="ol" gap="100" justify="center" wrap>
        {pagination.links.map((link, index) =>
          link === "gap" ? (
            <li key={`gap-${index}`} aria-hidden className="text-fg-muted text-body-sm px-100">
              …
            </li>
          ) : (
            <li key={link.page}>
              {link.current ? (
                <span aria-current="page" className={`${pageLinkClass} bg-brand text-fg-inverted font-bold`}>
                  {link.page}
                </span>
              ) : (
                <a href={link.href} aria-label={t("pagination.page", { page: link.page })} className={`${pageLinkClass} text-fg-muted hover:bg-surface-subtle hover:text-fg`}>
                  {link.page}
                </a>
              )}
            </li>
          )
        )}
        {pagination.nextHref && (
          <li>
            <a href={pagination.nextHref} rel="next" className={`${pageLinkClass} text-fg-muted hover:bg-surface-subtle hover:text-fg`}>
              {t("pagination.next")}
            </a>
          </li>
        )}
      </Row>
    </nav>
  )
}
